import { useMemo, useState } from "react";

import clsx from "clsx";

import FlagRuIcon from "assets/icons/colored/flag-ru.svg?react";
import FlagEnIcon from "assets/icons/colored/flag-us.svg?react";
import ArrowIcon from "assets/icons/outlined/dropdown-arrow.svg?react";

import useLanguage from "shared/hooks/useLanguage";
import { SupportedLanguages } from "shared/types";

// import styles from "./styles.module.scss";

import { Btn } from "./style";

interface LanguageDropdownProps {
	collapsed?: boolean;
	onOpenDropdown?: () => void;
}

const LanguageDropdown: React.FC<LanguageDropdownProps> = ({ collapsed, onOpenDropdown }) => {
	const { switchLanguage, getData: getLanguageData } = useLanguage();
	const { activeLanguage } = getLanguageData();

	const [openDropdown, setOpenDropdown] = useState(false);

	const languages = useMemo(
		() => [
			{ label: "English", value: SupportedLanguages.ENGLISH, code: "EN", icon: <FlagEnIcon /> },
			{ label: "Русский", value: SupportedLanguages.RUSSIAN, code: "RU", icon: <FlagRuIcon /> }
			// { label: "Русский", value: SupportedLanguages.RUSSIAN, icon: <FlagRuIcon /> },
			// { label: "Русский", value: SupportedLanguages.RUSSIAN, icon: <FlagRuIcon /> },
			// { label: "Русский", value: SupportedLanguages.RUSSIAN, icon: <FlagRuIcon /> },
			// { label: "Русский", value: SupportedLanguages.RUSSIAN, icon: <FlagRuIcon /> },
			// { label: "Русский", value: SupportedLanguages.RUSSIAN, icon: <FlagRuIcon /> }
		],
		[]
	);

	const currentLanguage = useMemo(() => languages.find(x => x.value === activeLanguage), [activeLanguage, languages]);

	const toggleDropdown = () => {
		if (!openDropdown && !!onOpenDropdown) {
			onOpenDropdown();
		}
		setOpenDropdown(!openDropdown);
	};

	const selectNewLanguage = (newLang: SupportedLanguages) => {
		switchLanguage(newLang);
		toggleDropdown();
	};

	return (
		<Btn className={clsx(collapsed && "collapsed")}>
			<div className={clsx("btn-content")}>
				<div
					className={clsx("flex items-center gap-[3px]", collapsed ? "w-full h-full" : "w-full h-7")}
					onClick={toggleDropdown}
				>
					<div className={clsx("btn-selector")}>
						<div className="flex flex-1 gap-1.5 items-center">
							<div className="w-6 h-6 rounded-full overflow-hidden shrink-0">{currentLanguage?.icon}</div>
							<p className={clsx("font-mic text-base text-yellow-350", collapsed && "hidden")}>
								{currentLanguage?.label}
							</p>
						</div>
						<ArrowIcon className={clsx("transition-all mr-1.5", openDropdown && "rotate-180", collapsed && "hidden")} />
					</div>
				</div>
				<div
					className={clsx(
						"dropdown",
						"transition-all",
						openDropdown ? "opacity-100 overflow-scroll max-h-[150px] mt-[5px]" : "opacity-0 overflow-hidden max-h-0"
					)}
				>
					{languages.map(l => (
						<div
							key={l.code}
							className="flex items-center gap-[3px] pl-[3px] py-0.5 hover:bg-[#F12814] transition-all"
							onClick={() => selectNewLanguage(l.value)}
						>
							<div className="w-[26px] h-[26px] rounded-full overflow-hidden flex items-center justify-center">
								{l.icon}
							</div>
							<p className="font-mic text-xl text-white">{l?.code}</p>
						</div>
					))}
				</div>
			</div>
		</Btn>
	);
};

export default LanguageDropdown;
